import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { finalize } from "rxjs/operators";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { CompanyService } from "src/app/services/company.service";
import { GlobalOverlayService } from "src/app/services/global-overlay.service";

import { FsJob } from "./../../models/FsJob";
import { FieldServiceService } from "./../../services/field-service.service";

@Component({
  selector: "app-field-service-details",
  templateUrl: "./field-service-details.component.html",
  styleUrls: ["./field-service-details.component.scss"],
  standalone: false,
})
export class FieldServiceDetailsComponent implements OnInit, OnDestroy {
  readonly routeNameConstants = RouteNameConstants;
  readonly localizationConstants = LocalizationConstants;

  subscription: Subscription;
  fsJob: FsJob;
  companyId: string;
  jobNumber: string;
  status: string; // planned or last job, need to fetch correct details

  constructor(
    public fsService: FieldServiceService,
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private router: Router,
    private globalOverlayService: GlobalOverlayService,
  ) {}

  ngOnInit() {
    this.subscription = this.onCompanyChange();
    this.companyId = this.route.snapshot.paramMap.get("companyId");
    this.jobNumber = this.route.snapshot.paramMap.get("jobNumber");
    this.status = this.route.snapshot.paramMap.get("status");

    if (
      !this.companyService.selectedCompany?.name ||
      this.companyService.selectedCompany.name != this.companyId
    )
      return;
    this.getFsJobDetails();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getFsJobDetails() {
    this.globalOverlayService.show();
    this.fsService
      .get(this.companyId, this.jobNumber)
      .pipe(finalize(() => this.globalOverlayService.close()))
      .subscribe((response) => {
        if (!response) return;
        this.fsJob = response;
      });
  }

  onCompanyChange() {
    return this.companyService.companyChange.subscribe(() => {
      this.router.navigate([RouteNameConstants.FIELD_SERVICE]);
    });
  }
}
